export enum ThemeQ2 {
  q2pay = 'q2pay',
  unimed = 'unimedPay',
}

const themeAPP: ThemeQ2 = process.env.REACT_APP_THEME_APPLICATION as ThemeQ2 || ThemeQ2.q2pay;
export { themeAPP };
